import { Typography } from '@weareopenr/component-library';
import styles from '../CreateOptionGroupModal.module.scss';
import { useMemo } from 'react';
import { downStreamExternalSystemIntegrationTypes } from '../../../constants';
import type { IOptionGroupValues } from '../types';
import { UseFormSetValue } from 'react-hook-form/dist/types/form';
import { IAggregator } from '../../../types/aggregator.types';
import { IOptionGroup } from '../../../types/menu.types';
import SelectableListWithControls from 'src/components/SelectableListWithControls';

export const SetPublicationExternalSystems = ({
  selectedExternalSystems,
  setValue,
  externalSystems,
  optionGroup,
}: {
  externalSystems: IAggregator[];
  selectedExternalSystems: string[];
  setValue: UseFormSetValue<IOptionGroupValues>;
  optionGroup?: IOptionGroup;
}) => {
  const checkboxOptions = useMemo(
    () =>
      externalSystems
        .filter((externalSystem) => downStreamExternalSystemIntegrationTypes.includes(externalSystem.integrationType))
        .map((externalSystem) => ({
          id: externalSystem.aggregatorId,
          label: externalSystem.name,
        })),
    [externalSystems],
  );
  return (
    <>
      <Typography size="xxlarge" weight="regular" className={styles['heading-text']}>
        {optionGroup ? 'Edit publishing channels for' : 'Set Publishing Channels'}
      </Typography>
      {optionGroup && (
        <Typography size="xxlarge" weight="bold" className={styles['heading-text']}>
          {optionGroup.name}
        </Typography>
      )}
      <Typography size="medium" weight="regular" className={styles['sub-heading-text']}>
        The selected publishing channels will apply to the modifier category. The category and all associated items will
        not be published to any channels that are not selected
      </Typography>
      <SelectableListWithControls
        options={checkboxOptions}
        selectedOptions={selectedExternalSystems}
        onChange={(selectedOptions) => setValue('externalSystems', selectedOptions)}
      />
    </>
  );
};
